import { render, staticRenderFns } from "./type_3.vue?vue&type=template&id=2eb3330f&scoped=true"
import script from "./type_3.vue?vue&type=script&lang=js"
export * from "./type_3.vue?vue&type=script&lang=js"
import style0 from "./type_3.vue?vue&type=style&index=0&id=2eb3330f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb3330f",
  null
  
)

export default component.exports